/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Importing icons for edit and delete actions
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";

export default function Tr({
  id,
  layer_name,
  layer_depth,
  pattern_id,
  onEdit,
  onDelete,
  isAllowedToEditOrDelete
}) {
  return (
    <>
      <tr>
        {/* Displaying the layer name */}
        <td className="first-col-td"><span className="extra_space_1">{layer_name}</span></td>
        
        {/* Displaying the layer depth */}
        <td className="text-center"><span>{layer_depth}</span></td>
        
        <td className="col-options">
          {/* Edit button */}
          <a
            onClick={(e) => {
              // Check if editing is allowed; if not, prevent default action
              isAllowedToEditOrDelete ?
              onEdit({
                id, // Pass layer ID for editing
                layer_name, // Pass layer name for editing
                layer_depth // Pass layer depth for editing
              })
              : e.preventDefault(); // Prevent default action if editing is not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permissions
            }}
          >
            <img className="edit-delete-icons" src={edit_logo} alt="Edit" /> {/* Edit icon */}
          </a>
          &nbsp;
          
          {/* Delete button */}
          <a
            onClick={(e) => {
              // Check if deleting is allowed; if not, prevent default action
              isAllowedToEditOrDelete ?
              onDelete({
                id, // Pass layer ID for deleting
                layer_name, // Pass layer name for deleting
                layer_depth, // Pass layer depth for deleting
                delete: true, // Indicate that this action is a delete
              })
              : e.preventDefault(); // Prevent default action if deleting is not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permissions
            }}
          >
            <img className="edit-delete-icons ms-3" src={tash_logo} alt="Delete" /> {/* Delete icon */}
          </a>
          &nbsp;
        </td>
      </tr>
    </>
  );
}
